/**
 * @voltxampere/schema — Assertion
 *
 * Per SPECS §1.5. A human-written assertion over circuit measurements,
 * parsed and evaluated by the engine's DSL (SPECS §6). The schema owns
 * only the serialized source string; parsing and evaluation live in
 * @voltxampere/engine.
 *
 * Sprint 9 deviation D3: the Sprint 9 prompt pseudo-code named the
 * DSL string field `source`. The schema established `expression` in
 * a prior sprint and Sprint 9 kept that name to avoid a breaking
 * schema change mid-sprint (a rename would force a 0.3.0 → 0.4.0
 * migration just for the field name). The field is the canonical
 * carrier for the parsed DSL string; `expression` is the durable
 * name. Settings-level shortcuts use plain `string[]` arrays under
 * `simulationSettings.{dc,transient}.assertions` per the Sprint 9
 * additive migration. See SPRINT_09_REVIEW.md (D3) for the full
 * resolution rationale.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { z } from "zod";
export const AssertionLocaleSchema = z.enum(["tr", "en"]);
export const AssertionSchema = z
    .object({
    id: z.string(),
    expression: z.string().min(1).max(500),
    locale: AssertionLocaleSchema.default("en"),
    enabled: z.boolean().default(true),
    description: z.string().optional(),
})
    .strict();
//# sourceMappingURL=assertion.js.map